import React from 'react'

import Attempts from '@/components/Attempts'

const AttemptsPage = () => <Attempts />

export default AttemptsPage
